export const ApiEndpoints = {
  // Authentication + Account
  CHANGE_PASSWORD: `auth-reset-password`,
  checkRoleUsers: `policy/getNumberOfUsersForPolicy`,
  PROCESS_TOKEN: `process-token`,
  PASSWORDLESS: `passwordless`,  

  // Logout and Session Expired
  logouts: `logOut`,

  // Claims
  createClaim: `claim`,
  saveClaim: `claim/save`,
  submitClaim: `claim/submit`,
  getImportedFile: `multiClaim/getImportedFile`,
  templateDownload: `multiClaim/templateDownload`,
  submitExportExcel: `multiClaim/submitExportExcel`,
  cancelExportExcel: `multiClaim/cancelExportExcel`,
  cancelUpload: `multiClaim/cancelUpload`,
  refreshData: `multiClaim/refreshData`,
  readOnlyList: `multiClaim/list`,
  documents: `multiClaim/documents`,
  uploadedDocumentsDetails: `multiClaim/getUploadedDocumentsDetails`,
  submittedList: `multiClaim/submittedList`,
  summaryPage: `multiClaim/summaryPage`,
  successPage: `multiClaim/successPage`,
  deleteSelected: `multiClaim/deleteSelected`,
  uploadDocumentClaims: `multiClaim/uploadDocument`,
  uploadSubDocument: `multiClaim/uploadSubDocument`,
  deleteSubDocument: `multiClaim/deleteSubDocument`,
  uploadFile: `multiClaim/uploadFile`,
  validateClaims: `multiClaim/validateClaims`,
  submitClaimsGwcc: `multiClaim/submitClaim`,
  updateClaimDetails: `multiClaim/updateClaimDetails`,
  getClaimsDetails: `claim/details`,
  getClaimSummary: `claim/summary`,
  getAllClaimIds: `claim/claimids`,
  ADDRESS_VALIDATION: `addressValidation`,
  withdrawClaim: 'claim/withdraw',
  reopenClaim: 'claim/reopen',
  deleteDraft: 'claim/DeleteDraft',
  SEND_ACK_INTERNATIONAL_EMAIL: 'email/InternationalClaimAck',

  // Claims Messaging
  POST_MESSAGE: `claim/postCustomerMessage`,
  getAllMessageClaimIds: 'claim/MessageClaimID',
  getMessageSummary: 'claim/MessageSummary',
  getAllMessageIds: 'claim/MessageID',
  getMessageDetails: 'claim/MessageDetails',

  // Documents
  uploadDocument: `/document/upload`,
  generateUploadToken: `/documents/generate-upload-token`,
  removeDocument: `/documents/remove`,
  downloadDocument: `documents/downloadDocument`,
  DOWNLOAD_PC_DOCUMENT: `documents/PCDownloadDocument`,
  DOWNLOAD_BC_DOCUMENT: `documents/BCDownloadDocument`,
  DOWNLOAD_XL_DOCUMENT: `documents/DownloadExcelInvoice`, // XL download for CBP/billiant  XL 2024
  DOWNLOAD_PDF_DOCUMENT: `documents/DownloadInvoice`, //PDF download for CBP/billiant PDF2024

  // Shipment Details
  getShipmentDetails: `shipments/`, //Check for duplicate tracking numbers
  getShipmentDetailsAutofill: `shipments/details/`, //tracking number full details
  HAPPY_RETURNS_SHIPMENT_DETAILS: `happy-returns/get-shipment-details`,

  // getUserLayouts Details
  getUserLayouts: `AzureSQL/getUserLayouts`,
  removeUserLayouts: `AzureSQL/deleteLayout`,
  getUserLayoutcolumns: `AzureSQL/getLayout`,
  submitUserLayoutcolumns: `AzureSQL/layout`,

  //DPAT
  getRedirect: `/DPAT/getRedirect`,
  getPayeeDetails: `/DPAT/getPayeeDetails`,

  //MetaData
  getMetaData: `/data/metadata`,

  //Policies
  getPolicyDetails: `policy/search-all`,
  getPolicyDetailsNoAuth: `policy/validate-all`,
  POLICY_CENTER_SEARCH: `pc/search`,
  getPermissions: `RLS/getPerms`,
  ADD_POLICIES: `policy/save`,
  GET_RENEWAL_QUESTIONNAIRE_INFO: `databricks/get-renewal-questionnaire`,
  SUBMIT_RENEWAL_QUESTIONNAIRE: `policy/renewal-questionnaire`,
  GET_VERIFICATION_CODE: `gvc`, //Get Verification Code (GVC)
  GET_PARTNER_POLICY: `policy/get-partner-policy`, //Retrieve SSP policy for partner portals - requires token

  //Billing
  BILLING_CENTER_SEARCH: `billing/BillingCenterDetails`,
  BILLIANT_PAYOR_INVOICE_SEARCH: `billing/PayorInvoice`,
  RETRIEVE_PAYMENT_PROFILE: 'bc/merchantProcessing/retrievePayment',
  SAVE_PAYMENT_PROFILE: 'bc/merchantProcessing',
  GET_ALL_PAYMENT_TOKENS: `billing/billingRetrieveTokens`,
  REMOVE_PAYMENT_PROFILE: 'bc/merchantProcessing',
  SAVE_PAYMENT_TOKEN: `bc/saveToken`,
  BILLING_TOKEN_PROCESSING: `billing/TokenProcessing`,
  BILLING_ONETIMEPAYMENT:  `billing/OneTimePayment`,

  //CRE claim Auto closer and disputes
  CLAIM_AUTO_CLOSER_DISPUTES: `claim/disputes`,

  //User
  UPDATE_USER_PREFERENCES: `updateUser/details`,
  GET_USER_IDS_FOR_POLICY: `users/getUserIDs`,
  GET_USER_INFO_LIST_FOR_POLICY: `users/getUsersForPolicy`,
  adminUpdateUser: 'admin/updateUser',
  adminDeleteUser: '/admin/deleteUser',
  inviteUser: 'users/invite',
  deleteInvitedUser: 'admin/deleteTempUser',
  RLS_Auto_Authentication: `RLSAutoAuthentication`,
  adminUserCount: `users/getAdminsForPolicy`,
  POLICY_UPDATE_CONTACT: `policy/UpdateContact`,
  DataBricks_POLICY_SEARCH: `policy/search-all`,
  DWpostIndicators: `digitalWallet/postIndicators`,
  DWgetIndicators: `digitalWallet/getIndicators`,
  consumerElectedInsurance: `consumer-elected-insurance`,
  DW_GetSummary: `digitalWallet/getSummary`,
  DW_ReviewEligibility: `DW/reviewEligibility`,
  DWstartSession: `digitalWallet/startSession`,

  //Logging
  uilog: `uilog`,
  LOGIN_LOG: `uilog/login`,
  UILOG_INTERNAL_USER: `uilog/internal`, //Internal user logs 2025
  CREATE_USER: `create-user-auth`,

  //Email Queue Endpoints
  RESET_PASSWORD: `email/resetPassword`,
  CREATE_ACCOUNT: `email/createAccount`,
  CONTACT_US: `email/contactUs`,

  //Profile endpoints
  GET_PAYEES: `payee/payeeDetails`,
  INITIATE_PUBLIC_SESSION_TRANSFER: `payee/initiateSessionTransfer`,
  CREATE_PAYEE: `payee/createPayee`,
  GET_CARD_DIGITS: `payee/getUserPaymentAccount`,
  UPDATE_ACH_INDICATOR: `payee/updateACHIndicator`,
  CHECK_DENIED_PARTY_V2: 'payee/v2/deniedParty',
  ORDER_ABSTRACTION: 'payee/orderAbstraction',

  //Terms & Conditions
  GET_TERM: `getTerm`, //No token needed

  GUEST_ACCESS: `users/guestAccess`, //No token needed
  AUTO_AUTH_PROFILE: `retrieve-customer-profile`,  //No token needed
  REFRESH_POWERBI_TOKEN: `powerbi/newembedparams`,
  SMART_UPLOAD: `smartupload`,
  HVCM: `HVCMSession`,
  DELIVERY_DEFENSE: `DeliveryDefense/startSession`,
  DELIVERY_DEFENSE_2_1: `DeliveryDefense/startSessionExt`,
  DD_CONTRACT_NUMBER: `policy/CreateContract`,

  //Tupss endpoint
  ISHIP: `iShip/getShipmentData`,
  tupssVerify: `iShip/verification`,
  CHECK_SHIPMENT: `iShip/checkShipment`,
  CHECK_CLAIMS: `check-claims/`,
  FRANCHISE_AUTH: `iShip/franchiseeautoauthentication`,
  GET_CONTRACT_ID: `databricks/get-contract-id`,
  TFCP_CONTACT_US: `email/tfcpContactUs`,
  TCCP_CONTACT_US: `email/tccpContactUs`,
  TCCP_CLAIMS: `claim/reporter-claims`,
  CLAIM_DETAIL_VERIFICATION_CODE: `email/tccpClaimSuccessVerification`,

  //Custmizable dashboard
  CLAIM_STATS: `claim/GetStats`,

  //Delivery Status
  DELIVERY_STATS: `claim/deliveryStatus`,

  //My Choice endpoints
  MYCHOICE_CLAIM_SUBMISSION_EMAIL: `email/mcClaimSubmission`,
  MYCHOICE_PAYMENT_RECEIPT_EMAIL: `email/mcPaymentReceiptDPAT`,
  DESCRPT_PARAMS: `myChoice/decryptUserDetails`,
  GET_ACCESS_TOKEN: `myChoice/getToken`,
  GET_MC_INFO: `myChoice/getEnrollment`,
  CREATE_POLICY: `policy/myChoice/create`,
  SUBMIT_POLICY: `policy/myChoice/submit`,
  MYCHOICE_ZIP_VALIDATION: `myChoice/validateZip`,
  CHECK_COVERAGE: `myChoice/check-coverage`,
  DPAT_ORDER_ABSTRACTION: `DPAT/orderAbstraction`,
  DPAT_RETRIEVE: `DPAT/retrievePaymentMethod`,
  PIRATE_SHIP_DECRYPT_TRACKING_NUMBER: `myChoice/decryptUserDetails`,

  //Customized Claims Portals (Channel Partners)
  DATABRICKS_SHIPMENT_DETAILS: `databricks/getShipmentDetails`,
  CCP_TN_VALIDATION: `databricks/cpp-tracking-number-validation`,
  CCP_VERIFICATION_CODE_EMAIL: `verification/ccp-verification-email`,
  CHECK_CCP_POLICY: `policy/get-cp-policy`,

  //Prospect
  BIND_POLICY: `smb-policy`,
  CHECK_EMAIL_VALIDITY: `getSMBCampaignEmail`,
  SMB_CONTACT_US: `email/smbContactUs`,

  //Confirmation of Coverage
  GET_COC_AGGREGATE: `confirmationCoverage/getAggregate`,
  GET_COC_LIST_OF_TRACKING_NUMBERS: `confirmationCoverage/getTrackingNumbers`,
  GET_COC_TRACKING_NUMBER_FULL_INFO: `confirmationCoverage/getTrackingDetail`,

  //Enterprise Affiliate
  POLICY_DETAILS: `policy/userPolicyDetails`,
  UPDATE_NICKNAME: `policy/updatePolicyNickname`,
  CHILD_POLICY_INFO: `policy/getChildAccountInfo`,
  SHIPPER_ACCOUNTS: `policy/getShipperAccountInfo`,
  SHIPPER_AND_GROUP_LIST: `policy/getShipperAccounts`,
  CHILD_POLICY_LIST: `policy/getChildPolicyList`,

  // IS4UPS
  UPSERT_ACQUISITION: `IS4UPS/upsert-acquisition`,
  GET_ACQUISITION: `IS4UPS/get-acquisition`,
  GET_SHIPPER_NUMBERS: `IS4UPS/get-shipper-numbers`,
  // VALIDATE_SHIPPER_NUMBER: `shipments/validate`, //Unused
  VALIDATE_MULTIPLE_SHIPPER_NUMBER: `shipments/validate-shipper-numbers`,
  CONVERSION_EMAIL: `email/IS4UPSConversionEmail`,
  LEAD_PROFILE_CREATE:`CRM/lead-create`,

  //Prospect Portal
  GET_CRM_DATA: `CRM/getData`,
  VERIFY_CRM_PROSPECT: `CRM/verify-prospect`,
  SAVE_ARMOR_SESSION: `policy/save-CRM-session`,
  GET_ARMOR_SESSION: `policy/get-CRM-session`,
  DELETE_ARMOR_SESSION: `policy/delete-CRM-session`,
  GET_QUOTE: `CRM/get-quote`,
  SEND_DECLINE_EMAIL: `email/ppDeclineCoverageEmail`,
  SEND_LEXUS_REJECTION_EMAIL: `email/ppApplicationEmails`,
  SEND_UNDER_REVIEW_EMAIL: `email/ppApplicationEmails`,
  CRM_POLICY_BIND: `CRM/policy-binding`,
  SEND__CUSTOMER_QUOTE_EMAIL: `email/CustomerQuote`,

  //reCAPTCHA
  RECAPTCHA_CHECK: `reCaptcha/verification`,

  //Self Service
  UPLOAD_LOGO: `policy/upload-cpp-image`,
  UPDATE_CCP_INFO: `policy/upsert-cpp-info`,
  GET_SSP_INFO: `policy/partner-customization`,
  SSP_WELCOME_EMAIL: `email/ccpWelcomeEmail`,
  GET_POLICY_GROUPCODE: `databricks/get-group-code`,
  INSERT_CCP_POLICY: `policy/insert-cpp-policy-number`,
  DELETE_CCP_POLICY: `policy/delete-cpp-info`,
  UPDATE_CCP_PARTNER: `policy/update-cpp-name`,

  //Flex App Service
  CBP_RETRIEVE_POLICY: `cbp-retrieve-policy`,

  //Docusign
  SEND_ENVELOPE: `docusign/send-envelope`,
  CHECK_DOCUSIGN_STATUS: `docusign/status`,
  UPLOAD_DOCUSIGN_DOCUMENT: `docusign/upload-document`,
  DOCUSIGN_FAILURE_EMAIL: `docusign/send-email`,
  getPolicyBanners: 'getPolicyBanners',
  IS4UPS_DOCUMENT_UPLOAD: 'IS4UPS/document-upload',

  //Smart Upload
  SmrtUpload_PolicyInfo: `smrtUpload/policies/activePolicyByPolicyNumber`, 
  SmrtUpload_ImportedFileHistory: `smrtUpload/ImportedFileHistory`,
  SmrtUpload_UploadShipmentFiles: `smrtUpload/shipments/uploadShipmentFiles`,
  SmrtUpload_DownloadTemplate: `smrtUpload/template/download`,
  SmrtUpload_ShipmentFileIds: `smrtUpload/shipments/shipmentFileIds`,
  SmrtUpload_ShipmentFileSummary: `smrtUpload/shipments/shipmentFileListByIds`,
  SmrtUpload_ShipmentList: `smrtUpload/shipments/shipmentList`,
  SmrtUpload_ReValidateColumns: `smrtUpload/shipments/reValidateColumns`,
  SmrtUpload_ShipmentTypes: `smrtUpload/shipments/shipmentTypes`,
  SmrtUpload_Countries: `smrtUpload/shipments/countries`,
  SmrtUpload_ShipmentEdit: `smrtUpload/shipments/edit`,
  SmrtUpload_ShipmentDelete: `smrtUpload/shipments/delete`,
  SmrtUpload_ShipmentSubmit: `smrtUpload/shipments/submit`,
  SmrtUpload_ShipmentStatusUpdate: `smrtUpload/shipments/updateStatus`,
  SmrtUpload_ShipmentCancel: `smrtUpload/shipments/cancleFile`,
  SmrtUpload_States: `smrtUpload/shipments/states`,
  SmrtUpload_SubmittedList: `smrtUpload/shipments/shipmentFinalList`,
  SmrtUpload_ExportToExcel: `smrtUpload/shipments/exportToExcel`,
  SmrtUpload_ShipmentListIds: `smrtUpload/shipments/shipmentListIds`,
  SmrtUpload_ShipmentListByIds: `smrtUpload/shipments/shipmentListByIds`,
  SmrtUpload_ServiceLevelData: `smrtUpload/shipments/serviceLevelData`,
  SmrtUpload_ShipmentListMinInfo: `smrtUpload/shipments/shipmentListMinimumInfo`,
  SmrtUpload_ShipmentListIdsForRemark: `smrtUpload/shipments/shipmentListIdsForRemark`
};
